import { SequenceTemplate } from "../../types";
import { DAILY_NEWSLETTER_TEMPLATES } from "./DailyNewsletterTemplates";

export const DAILY_NEWSLETTER_SEQUENCE: SequenceTemplate = {
  id: "daily-sequence-template",
  name: "Daily Newsletter Sequence",
  description: "Daily EV industry updates throughout the week",
  steps: [
    {
      ...DAILY_NEWSLETTER_TEMPLATES.monday.steps[0],
      step_number: 1,
    },
    {
      ...DAILY_NEWSLETTER_TEMPLATES.tuesday.steps[0],
      step_number: 2,
    },
    {
      ...DAILY_NEWSLETTER_TEMPLATES.wednesday.steps[0],
      step_number: 3,
    },
    {
      ...DAILY_NEWSLETTER_TEMPLATES.thursday.steps[0],
      step_number: 4,
    },
    {
      ...DAILY_NEWSLETTER_TEMPLATES.friday.steps[0],
      step_number: 5,
    }
  ]
};